var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmployeeGroupModal',_vm._g({attrs:{"value":_vm.isModalOpen,"entity":_vm.entity,"strategy":_vm.strategy},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var entity = ref.entity;
return [_c('EmployeeGroupHeaderFactory',_vm._g({attrs:{"isEditModal":_vm.isEditModal,"entity":entity}},_vm.$listeners))]}},{key:"stake-form",fn:function(ref){
var entity = ref.entity;
var updateEntity = ref.updateEntity;
return [(_vm.isEditModal)?_c('StakesTable',{attrs:{"selectedEmployeeGroup":entity}}):_c('AddStakeForm',{attrs:{"entity":entity},on:{"update:entity":updateEntity}})]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }